import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import { applyTheme, readTheme } from "@/lib/theme";

import Landing      from "@/pages/Landing";
import Legal        from "@/pages/Legal";
import Login        from "@/pages/Login";
import Register     from "@/pages/Register";
import DashboardApp from "@/pages/DashboardApp";
import AboutPublic  from "@/pages/AboutPublic";
import ContactPublic from "@/pages/ContactPublic";
import Features     from "@/pages/Features";
import CodePublic   from "@/pages/CodePublic";

export default function App() {
  useEffect(() => { applyTheme(readTheme()); }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/"            element={<Landing />} />
          <Route path="/legal"       element={<Legal />} />
          <Route path="/terms"       element={<Legal />} />
          <Route path="/privacy"     element={<Legal />} />
          <Route path="/login"       element={<Login />} />
          <Route path="/register"    element={<Register />} />
          <Route path="/about"       element={<AboutPublic />} />
          <Route path="/contact"     element={<ContactPublic />} />
          <Route path="/features"    element={<Features />} />
          <Route path="/code"        element={<CodePublic />} />
          <Route path="/app"         element={<ProtectedRoute><DashboardApp /></ProtectedRoute>} />
          <Route path="*"            element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}
